import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import {
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
  FetchPostData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { customGlobalFilter } from "utils/common-helpers"
import { punchApprovalColumns } from "utils/columns/Human Resource/humanResource"
import { LinkedinReportColumns } from "utils/columns/settings/LinkedinCols"

function TableContainer({ columns, data, toggleLoading, onClose }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => {
    setPageSize(10)
  }, [])
  // Render the UI for your table

  const [fixedHeading, setFixedHeading] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 40) {
      setFixedHeading(true)
    } else {
      setFixedHeading(false)
    }
  })

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body ">
            <div className="d-flex justify-content-between mb-3 align-items-center">
              {/* TITLE */}
              <div className="text-purple fs-5 fw-bold">
                Daily LinkedIn Report
              </div>

              {/* CANCEL BUTTON */}
              <button
                type="button"
                className="btn btn-red btn-label btn-sm"
                onClick={onClose}
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                Cancel
              </button>
            </div>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className={`fixed_view_payment_table`}>
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1 text-centers header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="fix-introducer-header"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row)
                    return (
                      <tr
                        className={`row-hover `}
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              className={`${cell.column.className}`}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const DailyLinkedinReport = ({ onClose }) => {
  const [modal_Access, setAccessDenied] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const token = secureLocalStorage.getItem("auth_token")

  const toggleLoading = loading => {
    setLoading(loading)
  }

  const getData = async () => {
    const response = await fetchNodeData(
      toggleLoading,
      `linkedin/report/${localStorage.getItem("auth_id")}`,
      token
    )
    console.log("res: ", response)
    if (response?.success) {
      setData(response.data)
    }
  }
  useEffect(() => {
    if (data?.length == 0) {
      getData()
    }
  }, [])

  const handleSave = async (data, count, date) => {
    try {
      if (!count || Number(count) < 0 || date.length <= 0) {
        Swal.fire({
          icon: "warning",
          text: "Please enter a valid count and date",
        })
        return
      }

      const payload = {
        id: data.id, // linkedinCounts.id
        accountID: data.account, // linkedin account id
        count: count,
        date: date,
        userId: localStorage.getItem("auth_id"),
      }

      const token = secureLocalStorage.getItem("auth_token")

      const res = await FetchNodePostData(
        setLoading,
        "linkedin/report", // ✅ API endpoint
        token,
        payload
      )

      console.log("reszdxcv sdlk nvc: ", res)
      if (res?.data?.success) {
        if (res?.status != 222) {
          Swal.fire({
            icon: "success",
            text: res?.message || "Count saved successfully",
          })
          getData()
        } else {
          Swal.fire({
            icon: "warning",
            text: res?.message || "Count for this date is already saved",
          })
        }
      } else {
        Swal.fire({
          icon: "error",
          text: res?.data?.message || "Failed to save count",
        })
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        text: err.message || "Something went wrong",
      })
    }
  }

  const fetchCounts = async date => {
        console.log("onChange date called: ", date)
      }

  const column1 = useMemo(() => LinkedinReportColumns(handleSave, fetchCounts), [])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="">
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <div className="responsive-table">
                  <TableContainer
                    columns={column1}
                    data={data}
                    toggleLoading={toggleLoading}
                    onClose={onClose}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default DailyLinkedinReport
